import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  style: {"display":"flex","align-items":"top","justify-content":"space-between"}
}
const _hoisted_2 = { class: "pr-6" }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 2 }
const _hoisted_5 = {
  key: 3,
  style: {"display":"flex","justify-content":"right"}
}
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 2 }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { style: {"overflow-wrap":"anywhere"} }
const _hoisted_11 = { style: {"font-size":"11pt"} }
const _hoisted_12 = {
  key: 0,
  style: {"overflow-wrap":"anywhere"}
}
const _hoisted_13 = { style: {"font-size":"11pt"} }
const _hoisted_14 = { style: {"display":"flex","align-items":"top","justify-content":"space-between"} }
const _hoisted_15 = { class: "pr-6" }
const _hoisted_16 = { class: "text-center" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { style: {"display":"flex","justify-content":"center"} }
const _hoisted_19 = { style: {"overflow-wrap":"anywhere"} }
const _hoisted_20 = { style: {"font-size":"11pt"} }
const _hoisted_21 = {
  key: 0,
  style: {"overflow-wrap":"anywhere"}
}
const _hoisted_22 = { style: {"font-size":"11pt"} }
const _hoisted_23 = { style: {"display":"flex","align-items":"top","justify-content":"space-between"} }
const _hoisted_24 = { class: "pr-6" }
const _hoisted_25 = { class: "text-center" }
const _hoisted_26 = { style: {"display":"flex","justify-content":"center"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_TagEditionDialog = _resolveComponent("TagEditionDialog")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      _cache[4] || (_cache[4] = _createElementVNode("h2", { class: "py-2" }, "Répartition des charges indirects secondaire sur le primaire", -1)),
      _createVNode(_component_v_row, { class: "d-flex justify-center" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "10" }, {
            default: _withCtx(() => [
              (_ctx.stockAssessment)
                ? (_openBlock(), _createBlock(_component_v_data_table, {
                    key: 0,
                    headers: _ctx.stockAssessment.analysisCenterHeaders,
                    items: _ctx.stockAssessment.analysisCenterTable,
                    class: "table mt-2",
                    "fixed-header": "",
                    "hide-default-footer": "",
                    density: "compact"
                  }, {
                    item: _withCtx((props) => [
                      _createElementVNode("tr", null, [
                        (props.item.values && props.item.distributionKeys)
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.stockAssessment.analysisCenterHeaders, (header, i) => {
                              return (_openBlock(), _createElementBlock("td", {
                                key: i,
                                class: _normalizeClass('text-' + header.align)
                              }, [
                                (header.value === 'title')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                                      _createElementVNode("span", _hoisted_2, _toDisplayString(props.item[header.value] || ""), 1),
                                      _createVNode(_component_v_icon, {
                                        icon: "$oss-edit",
                                        class: "mt-1",
                                        size: "small",
                                        color: "primary",
                                        onClick: _withModifiers(($event: any) => (
                                                _ctx.editTag(props.item.tagId, 'analysisCenterTable')
                                            ), ["stop"])
                                      }, null, 8, ["onClick"])
                                    ]))
                                  : (header.value === 'secondaryExpense')
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.newCommonFormatCurrency(
                                            props.item[header.value],
                                            undefined,
                                        ) || ""), 1))
                                    : (header.value === 'directExpense')
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString("-")))
                                      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                          _createVNode(_component_v_chip, {
                                            size: "x-small",
                                            dark: "",
                                            class: "mr-2"
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(_ctx.distributionFormat(
                                                    props.item.distributionKeys[header.value],
                                                )), 1)
                                            ]),
                                            _: 2
                                          }, 1024),
                                          _createElementVNode("span", null, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                    props.item.values[header.value],
                                                    undefined,
                                                ) || ""), 1)
                                        ]))
                              ], 2))
                            }), 128))
                          : (props.item.values && !props.item.distributionKeys)
                            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.stockAssessment.analysisCenterHeaders, (header, i) => {
                                return (_openBlock(), _createElementBlock("td", {
                                  key: i,
                                  class: _normalizeClass('text-' + header.align)
                                }, [
                                  (header.value === 'title')
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(props.item[header.value] || ""), 1))
                                    : (header.value === 'directExpense')
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.newCommonFormatCurrency(
                                            props.item[header.value],
                                            undefined,
                                        ) || ""), 1))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                props.item.values[header.value],
                                                undefined,
                                            ) || ""), 1))
                                ], 2))
                              }), 128))
                            : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.stockAssessment.analysisCenterHeaders, (header, i) => {
                                return (_openBlock(), _createElementBlock("td", {
                                  key: i,
                                  class: _normalizeClass('text-' + header.align)
                                }, [
                                  (header.value === 'title')
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_9, _cache[3] || (_cache[3] = [
                                        _createElementVNode("strong", null, "Répartition secondaire", -1)
                                      ])))
                                    : _createCommentVNode("", true)
                                ], 2))
                              }), 128))
                      ])
                    ]),
                    _: 1
                  }, 8, ["headers", "items"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _cache[5] || (_cache[5] = _createElementVNode("h2", { class: "py-2" }, "Répartition des charges indirects sur les charges", -1)),
      _createVNode(_component_v_row, { class: "d-flex justify-center" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "10" }, {
            default: _withCtx(() => [
              (_ctx.stockAssessment)
                ? (_openBlock(), _createBlock(_component_v_data_table, {
                    key: 0,
                    headers: _ctx.stockAssessment.expenseHeaders,
                    items: _ctx.stockAssessment.expenseTable,
                    class: "table mt-2",
                    "hide-default-footer": "",
                    "items-per-page": -1,
                    density: "compact"
                  }, {
                    headers: _withCtx(() => [
                      _createElementVNode("tr", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stockAssessment.expenseHeaders, (header, index) => {
                          return (_openBlock(), _createElementBlock("th", {
                            key: index,
                            class: "text-center",
                            style: {"border-bottom":"none"}
                          }, [
                            _createElementVNode("div", _hoisted_10, [
                              _createElementVNode("span", _hoisted_11, _toDisplayString(header.title), 1)
                            ]),
                            (header.symbol)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                  _createElementVNode("span", _hoisted_13, "(" + _toDisplayString(header.symbol) + ")", 1)
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ])
                    ]),
                    item: _withCtx((props) => [
                      _createElementVNode("tr", null, [
                        _createElementVNode("td", null, [
                          _createElementVNode("div", _hoisted_14, [
                            _createElementVNode("span", _hoisted_15, _toDisplayString(props.item.title || ""), 1),
                            _createVNode(_component_v_icon, {
                              icon: "$oss-edit",
                              class: "mt-1",
                              size: "small",
                              color: "primary",
                              onClick: _withModifiers(($event: any) => (_ctx.editTag(props.item.tagId, 'expenseTable')), ["stop"])
                            }, null, 8, ["onClick"])
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_16, [
                          (props.item.type !== 'directExpense')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_ctx.newCommonFormatCurrency(props.item.value, undefined)), 1))
                            : _createCommentVNode("", true)
                        ]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.item.products, (productDistribution, i) => {
                          return (_openBlock(), _createElementBlock("td", {
                            key: i,
                            class: "text-center"
                          }, [
                            _createElementVNode("div", _hoisted_18, [
                              _createVNode(_component_v_chip, {
                                size: "x-small",
                                dark: "",
                                class: "mr-2"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.distributionFormat(productDistribution.percentage)), 1)
                                ]),
                                _: 2
                              }, 1024),
                              _createElementVNode("span", null, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                productDistribution.value,
                                                undefined,
                                            ) || ""), 1)
                            ])
                          ]))
                        }), 128))
                      ])
                    ]),
                    _: 1
                  }, 8, ["headers", "items"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _cache[6] || (_cache[6] = _createElementVNode("h2", { class: "py-2" }, "Répartition des charges indirects sur les produits", -1)),
      _createVNode(_component_v_row, { class: "d-flex justify-center" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "10" }, {
            default: _withCtx(() => [
              (_ctx.stockAssessment)
                ? (_openBlock(), _createBlock(_component_v_data_table, {
                    key: 0,
                    headers: _ctx.stockAssessment.productHeaders,
                    items: _ctx.stockAssessment.productTable,
                    class: "table mt-2",
                    "hide-default-footer": "",
                    "items-per-page": -1,
                    density: "compact"
                  }, {
                    headers: _withCtx(() => [
                      _createElementVNode("tr", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stockAssessment.productHeaders, (header, index) => {
                          return (_openBlock(), _createElementBlock("th", {
                            key: index,
                            class: "text-center",
                            style: {"border-bottom":"none"}
                          }, [
                            _createElementVNode("div", _hoisted_19, [
                              _createElementVNode("span", _hoisted_20, _toDisplayString(header.title), 1)
                            ]),
                            (header.symbol)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                  _createElementVNode("span", _hoisted_22, "(" + _toDisplayString(header.symbol) + ")", 1)
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ])
                    ]),
                    item: _withCtx((props) => [
                      _createElementVNode("tr", null, [
                        _createElementVNode("td", null, [
                          _createElementVNode("div", _hoisted_23, [
                            _createElementVNode("span", _hoisted_24, _toDisplayString(props.item.title || ""), 1),
                            _createVNode(_component_v_icon, {
                              icon: "$oss-edit",
                              class: "mt-1",
                              size: "small",
                              color: "primary",
                              onClick: _withModifiers(($event: any) => (_ctx.editTag(props.item.tagId, 'productTable')), ["stop"])
                            }, null, 8, ["onClick"])
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_25, _toDisplayString(_ctx.newCommonFormatCurrency(props.item.value, undefined)), 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.item.products, (productDistribution, i) => {
                          return (_openBlock(), _createElementBlock("td", {
                            key: i,
                            class: "text-center"
                          }, [
                            _createElementVNode("div", _hoisted_26, [
                              _createVNode(_component_v_chip, {
                                size: "x-small",
                                dark: "",
                                class: "mr-2"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.distributionFormat(productDistribution.percentage)), 1)
                                ]),
                                _: 2
                              }, 1024),
                              _createElementVNode("span", null, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                productDistribution.value,
                                                undefined,
                                            ) || ""), 1)
                            ])
                          ]))
                        }), 128))
                      ])
                    ]),
                    _: 1
                  }, 8, ["headers", "items"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (_ctx.showTagDialog)
        ? (_openBlock(), _createBlock(_component_TagEditionDialog, {
            key: 0,
            modelValue: _ctx.showTagDialog,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.showTagDialog) = $event)),
            currentTag: _ctx.currentTag,
            companyId: _ctx.companyId,
            distribution: false,
            onUpsertedTag: _cache[1] || (_cache[1] = ($event: any) => (_ctx.tagDistributionsChanged($event))),
            onCancel: _cache[2] || (_cache[2] = ($event: any) => (_ctx.resetTag()))
          }, null, 8, ["modelValue", "currentTag", "companyId"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}